import React from "react";
import { Edit, ReactAdminComponentProps } from "react-admin";
import { EditActions } from "../../../common/form/FormActions";
import { VehicleMaintenanceForm } from "./VehicleMaintenanceForm";
import { useNotification } from "../../../../common/hooks/useNotification";
import { CustomResourceRouteParams } from "../../../../common/types";
import { RouteComponentProps } from "react-router-dom";

export const VehicleMaintenanceEdit = (
  props: RouteComponentProps<CustomResourceRouteParams> &
    ReactAdminComponentProps
) => {
  const notify = useNotification(props, "editSuccess");
  return (
    <Edit
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      mutationMode="pessimistic"
      transform={(record) => ({ ...record, vehicleId: props.match.params.id })}
      title="resources.assets-vehicle-maintenance.title.edit">
      <VehicleMaintenanceForm />
    </Edit>
  );
};
